import { motion, useReducedMotion } from "framer-motion";

// Hero visual — user-provided line drawing (communication / advocacy / giving).
// Used exactly as supplied; no recolouring or enhancement.
export const HeroVisual = () => {
  const reduce = useReducedMotion();
  return (
    <motion.img
      data-testid="hero-visual"
      src="/top-banner.webp"
      alt="Line drawing of people communicating and giving"
      loading="eager"
      initial={reduce ? { opacity: 1 } : { opacity: 0, scale: 0.96 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 1, delay: 0.5, ease: [0.33, 1, 0.68, 1] }}
      className="w-full max-w-sm mx-auto mix-blend-multiply"
    />
  );
};
